import type { IconName } from './Icon';

/**
 * Domain → icon vocabulary. Screens and navigation ask for a concept (`domainIcon('shipment')`) rather
 * than a glyph, so the whole product changes together when the mapping does.
 */
export const domainIcons = {
  shipment: 'truck',
  ocean: 'ship',
  air: 'plane',
  road: 'truck',
  rail: 'train-front',
  multimodal: 'route',
  warehouse: 'warehouse',
  inventory: 'boxes',
  order: 'clipboard-list',
  yard: 'container',
  task: 'list-checks',
  equipment: 'forklift',
  partner: 'users',
  report: 'bar-chart-3',
  studio: 'blocks',
  settings: 'settings',
  help: 'circle-help',
  home: 'home',
  notification: 'bell',
  search: 'search',
  user: 'circle-user',
  document: 'file-text',
  exception: 'triangle-alert',
  billing: 'receipt',
  customs: 'shield',
  workflow: 'workflow',
  ai: 'sparkles',
  controlTower: 'radar',
  inbound: 'inbox',
  outbound: 'send',
  dock: 'container',
  location: 'map-pin',
} as const satisfies Record<string, IconName>;

export type DomainIconKey = keyof typeof domainIcons;

export function domainIcon(key: DomainIconKey): IconName {
  return domainIcons[key];
}
